/**
 * Small "Featured on KAYAK Johannesburg Travel Guide" badge.
 * Used on the public Home page + Trips page.
 *
 * Behaviour intentionally simple — clean centred block, soft caption above the badge,
 * opens the Kayak guide in a new tab.
 */
export const KayakBadge = ({ className = '' }) => (
  <div
    className={`flex flex-col items-center text-center ${className}`}
    data-testid="kayak-badge"
  >
    <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-3">
      As featured on
    </p>
    <a
      href="https://www.kayak.co.uk/Johannesburg.26961.guide"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block transition-transform hover:scale-105 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FF6B35] rounded"
      data-testid="kayak-badge-link"
      aria-label="View KAYAK Johannesburg travel guide (opens in new tab)"
    >
      <img
        src="https://content.r9cdn.net/res/images/horizon/ui/seo/marketing/poibadges/POI_BADGES_GUIDES_ORANGE.png?v=e9d3a144da5c831c5049ece6ebfc57d47e904ab7&cluster=5"
        alt="KAYAK Johannesburg Travel Guide"
        height="150"
        style={{ height: '150px' }}
      />
    </a>
  </div>
);

export default KayakBadge;
